import React, {Component} from 'react';
import {Table, Button, Input} from 'reactstrap';
import {Link} from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Redirect} from 'react-router-dom';
import './OrgsList.css';
import {sharedLabelsPath} from '../../../reducers/common/localization';
import {LABEL_PATH_BY_ORG_TYPE} from '../../../reducers/organization/organizations';
import ResendActivationAnchor from '../orgModal/resendActivationAnchor/ResendActivationAnchor.container';
import PaginationOrgs from '../../commonComponents/paginationComponent/PaginationOrgs.container';
import IconContainer from '../../commonComponents/iconContainer/IconContainer';
import {SUB_ROLES} from '../../../reducers/account/role';
import {Utils} from '../../../utils/utils';
import Select from '../../commonComponents/customSelect/CustomSelect.container';
import RemoveOrgModal from '../removeOrgModal/RemoveOrgModal.container';
import FormWrapper from '../../commonComponents/formWrapper/FormWrapper.container';

const SUCCESS_MESSAGE_PATH_BY_ACTION = {
    RESEND_ACTIVATION: 'resend_activation.success_message',
    REMOVE: 'orgs.remove_org_success_message'
}

class OrgsList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOrgId: null,
            resendActivationEmail: null,
            countryFilter: props.countryFilter,
            selectedOrgData: null,
            successMessage: null,
            currentCountryFilter: null,
            filtering: false,
            nameFilter: ''
        };
    }

    componentDidMount() {
        this.props.onMount();
    }

    componentWillUnmount() {
        this.props.onSetContinent(null);
        this.props.onClearFilter();
    }

    render() {
        if (!_.isNil(this.state.selectedOrgId)) {
            return <Redirect to={'/organization?id=' + this.state.selectedOrgId} push/>;
        }

        return (
            <div className='org-list-container'>
                <FormWrapper successMessage={_.get(this.props.translation, this.state.successMessage)}>
                    <h4 className="page-label">{_.get(this.props.translation, 'orgs.label')}</h4>
                    {this.props.subRoles.includes(SUB_ROLES.ROOT) || this.props.subRoles.includes(SUB_ROLES.FA) ?
                        <div className="buttons-group">
                            <Button tag={Link} className='add-org-button olive-green-btn'
                                    to="/register-org">{_.get(this.props.translation, 'orgs.add_org')}</Button>
                        </div> : null}
                    {this.renderContinentAndCountryFilter()}
                    <PaginationOrgs validated countryFilter={this.state.countryFilter}/>
                    {this.renderContent()}
                    <RemoveOrgModal data={this.state.selectedOrgData} validated/>
                    <ResendActivationAnchor email={this.state.resendActivationEmail}/>
                </FormWrapper>
            </div>
        )
    }

    renderContent = () => {
        if (this.props.loading && !this.state.filtering) {
            return (
                <div className="org-status-message-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>
                </div>
            );
        }
        if ((_.isNil(this.props.data) || this.props.data.length === 0) && !this.state.filtering) {
            return (
                <div className="org-status-message-container">
                    <h5>{_.get(this.props.translation, 'orgs.no_data_label')}</h5>
                </div>
            );
        }
        return (
            <Table className='orgs-list-table'>
                <thead>
                <tr>
                    <th className='name-th'>{_.get(this.props.translation, 'orgs.org_label')}
                        <Input id='name-input'
                               value={this.state.nameFilter}
                               onChange={this.handleChangeFilterValue}
                               onKeyDown={this.handleKeyDown}
                               onBlur={this.handleFilter}
                               className='name-filter-input'
                               bsSize='sm'
                               placeholder={_.get(this.props.translation, 'validated_domains.filter_by_name_label')}/>
                    </th>
                    <th>{_.get(this.props.translation, 'orgs.org_type_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.anchor_label')}</th>
                    <th>{_.get(this.props.translation, 'orgs.location_label')}</th>
                    <th/>
                    <th/>
                    {this.props.subRoles.includes(SUB_ROLES.ROOT) || this.props.subRoles.includes(SUB_ROLES.FA) ? <th/> : null}
                </tr>
                </thead>
                <tbody>
                {this.renderOrgsData()}
                </tbody>
            </Table>
        );

    };

    handleChangeFilterValue = (e) => {
        this.setState({nameFilter: e.target.value});
    }

    handleKeyDown = (e) => {
        if (e.keyCode === 13) {
            this.handleFilter();
        }
    }

    handleFilter = () => {
        if (!_.isEmpty(this.state.countryFilter) || !_.isEmpty(this.state.nameFilter)) {
            this.setState({filtering: true});
        }
        this.props.onChangeFilter(this.state.countryFilter, this.state.nameFilter);
    }

    renderOrgsData = () => {
        return _.map(this.props.data, (orgData, index) => (
            <tr
                className={'orgs-list-row ' + (orgData.active ? '' : 'not-active')}
                key={index}>
                <td
                    className='org-name-td'
                    data-th={_.get(this.props.translation, 'orgs.org_label') + ':'}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {orgData.orgName}
                </td>
                <td
                    className='org-type-td'
                    data-th={_.get(this.props.translation, 'orgs.org_type_label') + ':'}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {_.get(this.props.translation, sharedLabelsPath[LABEL_PATH_BY_ORG_TYPE[orgData.orgType]])}
                </td>
                <td
                    className='anchor-td'
                    data-th={_.get(this.props.translation, 'orgs.anchor_label') + ':'}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    <div>{orgData.anchorName + '\n'}</div>
                    <a onClick={this.handleMailtoLinkClick}
                       href={'mailto:' + orgData.anchorEmail}>{orgData.anchorEmail}</a>
                </td>
                <td
                    className='location-td'
                    data-th={_.get(this.props.translation, 'orgs.location_label') + ':'}
                    onClick={this.handleTableRowClick(orgData.id)}>
                    {_.get(this.props.translation, 'countries.' + orgData.location)}
                </td>
                <td className='resend-activation-link'
                    onClick={this.handleTableRowClick(orgData.id)}>{this.renderResendActivationButton(orgData)}</td>
                <td className='orgs-list-create-icon-td' onClick={this.handleTableRowClick(orgData.id)}>
                    <IconContainer
                        key={'create' + index}
                        icon='create'
                        className='orgs-list-create-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.edit_button)}
                    />
                </td>
                {this.props.subRoles.includes(SUB_ROLES.ROOT) || this.props.subRoles.includes(SUB_ROLES.FA) ? <td className='orgs-list-remove-icon-td'>
                    {orgData.isBava ? null : <IconContainer
                        onClick={this.handleRemoveButtonClick(orgData)}
                        key={'trash' + index}
                        icon='trash'
                        className='orgs-list-remove-icon'
                        title={_.get(this.props.translation, sharedLabelsPath.remove_button)}
                    />}
                </td> : null}
            </tr>
        ));
    };

    renderContinentAndCountryFilter = () => {
        let continentsOptions = [
            {value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label)},
            ...Utils.getLocationOptions(
                this.props.continents,
                _.get(this.props.translation, sharedLabelsPath.continents)
            )
        ];

        let countriesOptions = [
            {value: null, label: _.get(this.props.translation, sharedLabelsPath.all_label)},
            ...Utils.getLocationOptions(
                this.props.countries,
                _.get(this.props.translation, sharedLabelsPath.countries)
            )
        ];

        return (
            <div className="filters-container">
                <div className="continent-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.continent_label)}</h6>
                    <Select
                        className="continent-filter-select"
                        selectedOption={_.find(continentsOptions, option => option.value === this.props.continentCode || (_.isEmpty(option.value) && _.isEmpty(this.props.continentCode)))}
                        options={continentsOptions}
                        onSelect={this.handleChangeContinentSelect}
                    />
                </div>
                <div className="country-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.country_label)}</h6>
                    <Select
                        className="country-filter-select"
                        selectedOption={_.find(countriesOptions, option => option.value === this.state.countryFilter)}
                        options={countriesOptions}
                        onSelect={this.handleChangeCountrySelect}
                    />
                </div>
                <div className="name-filter-container">
                    <h6>{_.get(this.props.translation, sharedLabelsPath.org_label)}</h6>
                    <Input id='name-filter-input'
                           value={this.state.nameFilter}
                           onChange={this.handleChangeFilterValue}
                           onKeyDown={this.handleKeyDown}
                           onBlur={this.handleFilter}
                           className='name-filter-input'
                           bsSize='sm'
                           placeholder={_.get(this.props.translation, 'validated_domains.filter_by_name_label')}/>
                </div>
            </div>
        )
    };

    handleChangeContinentSelect = (selectedOption) => {
        this.setState({countryFilter: ''});
        this.props.onSetContinent(selectedOption.value);
    };

    handleChangeCountrySelect = (selectedOption) => {
        this.setState({countryFilter: selectedOption.value, filtering: !!selectedOption.value || _.isEmpty(this.state.nameFilter)})
        this.props.onChangeFilter(selectedOption.value, this.state.nameFilter);
    };

    renderResendActivationButton(org) {
        if (org.active) {
            return null;
        }
        return (
            <Button className="btn-sm" color="link" onClick={this.onResendActivationClick(org.anchorEmail)}>
                {_.get(this.props.translation, 'resend_activation.title')}
            </Button>
        );
    }

    handleMailtoLinkClick = (e) => {
        e.stopPropagation();
    };

    onResendActivationClick = (email) => (e) => {
        e.stopPropagation();
        this.setState({resendActivationEmail: email, successMessage: SUCCESS_MESSAGE_PATH_BY_ACTION.RESEND_ACTIVATION});

        this.props.onResendActivation();
    };

    handleTableRowClick = (orgId) => () => {
        this.setState({selectedOrgId: orgId});
    };

    handleRemoveButtonClick = (data) => (e) => {
        e.stopPropagation();
        this.setState({selectedOrgData: data, successMessage: SUCCESS_MESSAGE_PATH_BY_ACTION.REMOVE});
        this.props.onRemoveOrg();
    }
}

const OrgShape = PropTypes.shape({
    id: PropTypes.string.isRequired,
    anchorName: PropTypes.string.isRequired,
    anchorEmail: PropTypes.string.isRequired,
    active: PropTypes.bool.isRequired,
    location: PropTypes.string.isRequired,
    orgName: PropTypes.string.isRequired
});

OrgsList.propTypes = {
    translation: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    data: PropTypes.arrayOf(OrgShape),
    subRoles: PropTypes.array,
    onMount: PropTypes.func.isRequired,
    onResendActivation: PropTypes.func.isRequired,
    onRemoveOrg: PropTypes.func.isRequired,
    onClearFilter: PropTypes.func.isRequired,
    onSetContinent: PropTypes.func.isRequired,
    onChangeFilter: PropTypes.func.isRequired,
};

export default OrgsList;



// WEBPACK FOOTER //
// ./src/components/organizationManagement/orgsList/OrgsList.js